/* 
  Global settings for the pg-field component and it's
  child components.

  the library provides a default implementation but it can be overridden 
  for you app by providing PG_FIELD_OPTIONS_TOKEN with your values

*/
import { InjectionToken } from '@angular/core';
export type PgFieldSize = 'sm' | 'md' | null;

export interface PgFieldOptions {
  hidePrefixIconsOnMobile: boolean;
  fieldSize: PgFieldSize;
}

export const PgFieldDefaultOptions: PgFieldOptions = {
  hidePrefixIconsOnMobile: true,
  fieldSize: null,
};

export const PG_FIELD_OPTIONS_TOKEN = new InjectionToken('PgFieldOptions');

export const PG_FIELD_OPTIONS_DEFAULT_PROVIDER = {
  provide: PG_FIELD_OPTIONS_TOKEN,
  useValue: PgFieldDefaultOptions,
};
